export const AGENT_CANCEL_CORRECT_BEGIN = "AGENT_CANCEL_CORRECT_BEGIN";
export const AGENT_CANCEL_CORRECT_SUCCESS = "AGENT_CANCEL_CORRECT_SUCCESS";
export const AGENT_CANCEL_CORRECT_FAILURE = "AGENT_CANCEL_CORRECT_FAILURE";
